import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteCompany = createAsyncThunk(
  'listCompanies/fetchDeleteCompany',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteCompany(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteCompanySlice = createSlice({
  name: 'Companies/delete',
  initialState,
  reducers: {
    resetDeleteCompany: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteCompany.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteCompany.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteCompany.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteCompanySlice.reducer
export const { resetDeleteCompany } = deleteCompanySlice.actions
